import {useCallback, useState} from 'react';
import {useNavigate} from "react-router";

export default (apiFunc) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const urlAuthentication = [
        'Logout', 'Users', 'Parts',
        'ElectronicHousingUnits', 'Vehicle', 'Company',
        'PartSpecifications', 'Order'];

        const request = useCallback(async (apiFunc) => {
            try {
                setLoading(true);
                const response = await apiFunc;
                setData(response.data);
                setError(null); // Clear any previous error
            } catch (error) {
                setError(error);
                const urlCheck = urlAuthentication.some(x => error.response?.request?.responseURL.includes(x));
                const unauthorized = error.response?.status === 401;
                if (urlCheck && unauthorized) {
                    navigate("/unauthorized");
                }
                throw error;  // Rethrow the error so the caller can handle it
            } finally {
                setLoading(false);
            }
        }, [data]);

    const reset = useCallback(async (apiFunc) => {
        setData(null);
        setError(null);
    }, []);

    const set = useCallback(async (apiFunc) => {
        setData(apiFunc);
    }, []);

    return {
        data,
        error,
        loading,
        request,
        reset,
        set
    };
};